import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeLargeCta'
 * @name TypeLargeCtaFields
 * @type {TypeLargeCtaFields}
 * @memberof TypeLargeCta
 */
export interface TypeLargeCtaFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'text' (Text)
     * @name Text
     * @localized true
     */
    text: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'url' (URL)
     * @name URL
     * @localized false
     */
    url: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'type' (Type)
     * @name Type
     * @localized false
     */
    type: EntryFieldTypes.Symbol<"Blue" | "Green" | "link-color-button" | "primary-button" | "secondary-button">;
    /**
     * Field type definition for field 'size' (Size)
     * @name Size
     * @localized false
     */
    size?: EntryFieldTypes.Symbol<"Large">;
    /**
     * Field type definition for field 'openInNewTab' (Open In New Tab)
     * @name Open In New Tab
     * @localized false
     */
    openInNewTab?: EntryFieldTypes.Boolean;
}

/**
 * Entry skeleton type definition for content type 'largeCta' (Large CTA)
 * @name TypeLargeCtaSkeleton
 * @type {TypeLargeCtaSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T01:55:41.237Z
 * @version 28
 */
export type TypeLargeCtaSkeleton = EntrySkeletonType<TypeLargeCtaFields, "largeCta">;
/**
 * Entry type definition for content type 'largeCta' (Large CTA)
 * @name TypeLargeCta
 * @type {TypeLargeCta}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T01:55:41.237Z
 * @version 28
 */
export type TypeLargeCta<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeLargeCtaSkeleton, Modifiers, Locales>;

export function isTypeLargeCta<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeLargeCta<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'largeCta'
}
